import { Controller } from "@hotwired/stimulus"
import { interpolate } from "../../utils/addon-cost-line.util"
import { formatBillingAmount, vatCents } from "../../utils/billing-amount.util"

// The order summary of a scheduled downgrade (Task 10 D-1): the next period's
// price is the target plan plus every kept extra, so it follows the keep
// steppers (billing--downgrade-keep:change). The server renders the plan and
// unit prices as integer cents and the VAT rate; VAT is rounded the server's
// way (vatCents), so a recompute lands on the cent the server would render.
export default class extends Controller {
  static targets = ["keptLine", "keptLabel", "keptAmount", "subtotal", "vat", "total"]
  static values = {
    planCents: Number,
    vatRate: Number,
    currencyFormat: { type: Object, default: {} },
    texts: { type: Object, default: {} }
  }

  keepChanged(event) {
    const { featureKey, quantity } = event.detail || {}
    const line = this.keptLineTargets.find((element) => element.dataset.featureKey === featureKey)
    if (!line) return

    line.dataset.quantity = String(quantity)
    this.render()
  }

  render() {
    let netCents = this.planCentsValue
    this.keptLineTargets.forEach((line, index) => {
      const quantity = Number.parseInt(line.dataset.quantity, 10) || 0
      const cents = quantity * Number(line.dataset.unitCents)
      netCents += cents
      this.#renderLine(line, index, quantity, cents)
    })
    const vat = vatCents(netCents, this.vatRateValue)
    if (this.hasSubtotalTarget) this.subtotalTarget.textContent = this.#format(netCents)
    if (this.hasVatTarget) this.vatTarget.textContent = this.#format(vat)
    if (this.hasTotalTarget) this.totalTarget.textContent = this.#format(netCents + vat)
  }

  // A line at 0 is hidden with d-none: [hidden] loses to the line's d-flex.
  #renderLine(line, index, quantity, cents) {
    line.classList.toggle("d-none", quantity === 0)
    const label = this.keptLabelTargets[index]
    if (label)
      label.textContent = interpolate(this.textsValue.line || "%{name} × %{count}", {
        name: line.dataset.name,
        count: quantity
      })
    const amount = this.keptAmountTargets[index]
    if (amount) amount.textContent = this.#format(cents)
  }

  #format(cents) {
    return formatBillingAmount(cents / 100, this.currencyFormatValue)
  }
}
